<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.userManagement") }}</h4>
    </div>
    <div class="brick_box mb-3 mt-3">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>
              <select
                class="int_type01"
                v-model="form.searchType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="loginId">{{ $t("management.id") }}</option>
                <option value="userName">{{ $t("common.name") }}</option>
              </select>
            </th>
            <td>
              <input
                type="text"
                id="searchWord"
                v-model="form.searchWord"
                @keyup.enter="searchBtn"
                name="searchWord"
                value=""
                class="int_type01"
              />
            </td>
            <th>{{ $t("management.approvalStatus") }}</th>
            <td>
              <select
                class="int_type01"
                v-model="form.searchState"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="1">{{ $t("management.approved") }}</option>
                <option value="0">{{ $t("management.disApproved") }}</option>
              </select>
            </td>
            <th>{{ $t("management.userType") }}</th>
            <td>
              <select class="int_type01" v-model="form.userDiv" aria-label="sort select">
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="1">{{ $t("management.employees") }}</option>
                <option value="2">{{ $t("management.dealer") }}</option>
                <option value="3">{{ $t("management.user") }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.authType") }}</th>
            <td>
              <select
                class="int_type01"
                @change="form.authYn = ''"
                v-model="form.authType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("management.selectAuthType") }}--</option>
                <option value="PDF VIEW">{{ $t("common.pdfView") }}</option>
                <option value="PDF DOWNLOAD">{{ $t("common.pdfDownload") }}</option>
                <option value="WEBHELP VIEW">{{ $t("common.webhelpView") }}</option>
                <option value="WEBHELP DOWNLOAD">
                  {{ $t("common.webhelpDownload") }}
                </option>
              </select>
            </td>
            <th>{{ $t("management.authStatus") }}</th>
            <td colspan="2">
              <select
                class="int_type01"
                v-model="form.authYn"
                aria-label="sort select"
                :disabled="form.authType == ''"
                v-bind:class="{ bg_disabled: form.authType == '' }"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="Y">{{ $t("common.authorized") }}</option>
                <option value="N">{{ $t("common.unAuthorized") }}</option>
              </select>
            </td>
            <td class="custom_text_right">
              <button @click="searchBtn" class="btn btn-primary">
                {{ $t("common.search") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="mb-2 custom_text_right">
        <router-link
          type="button"
          :to="{ name: 'userMgmtView' }"
          class="btn btn-primary"
          >{{ $t("common.add") }}</router-link
        >
        <a
          @click="downExcel()"
          href="javascript:void(0)"
          class="btn btn-secondary btn-md m-1"
          >{{ $t("common.excelDownload") }}</a
        >
      </div>
      <div>
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("common.name") }}</th>
              <th class="mobile_h">{{ $t("common.userType") }}</th>
              <th class="mobile_h">{{ $t("common.region") }}</th>
              <th class="mobile_h">{{ $t("management.approvalStatus") }}</th>
              <th class="mobile_h">{{ $t("management.lastLoginDatetime") }}</th>
              <th class="mobile_h">{{ $t("management.menuAuthority") }}</th>
            </tr>
          </thead>
          <tbody v-if="members.length != 0">
            <tr v-for="(mem, index) in members" :key="index">
              <td class="text-left">
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                  >{{ mem.loginId }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                  >{{ mem.userName }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                >
                  {{
                    mem.userDiv == "1"
                      ? $t("management.employees")
                      : mem.userDiv == "2"
                      ? $t("management.dealer")
                      : $t("management.userRole")
                  }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                  >{{ mem.countryCode }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                >
                  {{
                    mem.activeFlag == "1"
                      ? $t("management.approved")
                      : $t("management.disApproved")
                  }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMgmtView', params: { loginId: mem.loginId } }"
                  >{{ mem.lastLoginDatetime }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'userMenuMgmt', params: { loginId: mem.loginId } }"
                  class="btn btn-primary btn-sm"
                  >{{ $t("management.menu") }}</router-link
                >
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="members.length != 0" class="paging_nav">
      <div class="paging_nav">
        <a
          href="javascript:void(0)"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a
            href="javascript:void(0)"
            v-else
            @click="searchPage(pagingVO.startPage + index)"
            >{{ pagingVO.startPage + index }}</a
          >
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="javascript:void(0)"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="javascript:void(0)"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { getAllUserList, downExcel } from "@/api/user";
export default {
  data() {
    return {
      members: "",
      pagingVO: "",
      form: {
        searchType: "",
        searchWord: "",
        userDiv: "",
        loginId: "",
        searchState: "",
        searchAttributeId: "",
        authType: "",
        authYn: "",
        page: 1,
      },
      allMenuList: [],
      parentMenu: [],
      childMenu: [],
      userMenuList: [],
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getAllUserList(this.form);
        this.members = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
        // 기존 검색 값 유지
        if (data.searchObj != null) {
          this.form = data.searchObj;
        }
      } catch (error) {
        console.log(error);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData();
    },
    // 검색버튼
    searchBtn() {
      if (this.form.authType != null && this.form.authType != "") {
        if (this.form.authYn == null || this.form.authYn == "") {
          alert(this.$t("alert.pleaseSelectAuthStatus"));
          return;
        }
      }
      this.form.page = 1;
      this.$store.commit("setSearchObj", this.form);
      this.fetchData();
    },
    async downExcel() {
      let result = await downExcel(this.form);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "UserList.xls";
      link.click();
      window.URL.revokeObjectURL(url);
    },
  },
  mounted() {
    if (this.$store.getters.getSearchObj != "") {
      this.form = this.$store.getters.getSearchObj;
      if (this.$store.getters.getPage != 1) {
        this.form.page = this.$store.getters.getPage;
        this.fetchData(this.form.page);
      } else {
        this.fetchData(this.form.page);
      }
    } else {
      this.fetchData(this.form.page);
    }
  },
};
</script>

<style scoped></style>
